import validateEmail from "@/lib/validateemail";

export interface NormalRosterValidationRow {
  name: string;
  email: string;
  electee: boolean;
  elector: boolean;
}

export function hasRoleError(row: NormalRosterValidationRow): boolean {
  return row.name.trim() !== "" && !row.electee && !row.elector;
}

export function hasInvalidEmail(row: NormalRosterValidationRow): boolean {
  return row.email.trim() !== "" && !validateEmail(row.email.trim());
}

export function hasMissingElectorEmail(row: NormalRosterValidationRow): boolean {
  return row.name.trim() !== "" && row.elector && row.email.trim() === "";
}

export function getFirstNormalRosterValidationError(
  rows: NormalRosterValidationRow[],
  t: (key: string, options?: Record<string, unknown>) => string
): string | null {
  const namedRows = rows.filter((row) => row.name.trim() !== "");

  const missingRole = namedRows.find((row) => hasRoleError(row));
  if (missingRole) {
    return t("error_role_required_row", { name: missingRole.name });
  }

  const missingElectorEmail = namedRows.find((row) => hasMissingElectorEmail(row));
  if (missingElectorEmail) {
    return t("error_elector_email_required", { name: missingElectorEmail.name });
  }

  const invalidElectorEmail = namedRows.find((row) => row.elector && hasInvalidEmail(row));
  if (invalidElectorEmail) {
    return t("error_elector_invalid_email", { name: invalidElectorEmail.name });
  }

  return null;
}
